import { render, staticRenderFns } from "./SaldosTodos.vue?vue&type=template&id=4077109c&scoped=true"
import script from "./SaldosTodos.vue?vue&type=script&lang=ts"
export * from "./SaldosTodos.vue?vue&type=script&lang=ts"
import style0 from "./SaldosTodos.vue?vue&type=style&index=0&id=4077109c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4077109c",
  null
  
)

export default component.exports